import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n, usePageTitle } from '../../i18n/index.jsx';
import Logo from '../Logo.jsx';

// Shared frame for sign-in / sign-up / account completion: warm page
// background, one centred card (title top-left, logo top-right, one-line
// subtitle), and an optional line under the card.
export default function AuthLayout({ titleKey, title, lead, children, below }) {
  const { t } = useI18n();
  usePageTitle(titleKey);
  return (
    <div className="auth-bg">
      <div className="auth-wrap">
        <div className="auth-panel">
          <div className="auth-panel-head">
            <div>
              <h1>{title}</h1>
              {lead && <p className="auth-panel-lead">{lead}</p>}
            </div>
            <Link to="/" className="auth-panel-logo" aria-label={t('brand.name')}><Logo size={44} /></Link>
          </div>
          {children}
        </div>
        {below && <p className="auth-below">{below}</p>}
      </div>
    </div>
  );
}

export function OrDivider() {
  const { t } = useI18n();
  return <div className="auth-or" role="separator"><span>{t('auth.or')}</span></div>;
}
